"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var BASE_ICON = "flex m-auto";
var DEFAULT_ICON = BASE_ICON + " text-current";
var PRIMARY_ICON = BASE_ICON + " text-sorbus-default-default";
var SECONDARY_ICON = BASE_ICON + " text-lochivar-default hover:text-lochivar-dark";
var NEGATIVE_ICON = BASE_ICON + " text-white";
var classForMode = function (mode) {
    switch (mode) {
        case "primary":
            return PRIMARY_ICON;
        case "secondary":
            return SECONDARY_ICON;
        case "negative":
            return NEGATIVE_ICON;
        default:
            return DEFAULT_ICON;
    }
};
var Icon = function (_a) {
    var icon = _a.icon, mode = _a.mode;
    return (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: classForMode(mode), icon: icon }, void 0);
};
exports.Icon = Icon;
